import React from "react";
import Radium from "radium";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";
import FromCacheCallout from "./partials/from-cache-callout.jsx";
import AnalyticsFilterWidget from "./partials/analytics-filter-widget.jsx";

import moment from "moment";

import * as util from "../util";

const _color = percent =>
  percent < 0.5
    ? "#f44336"
    : percent < 0.75
      ? "#ff9800"
      : percent < 0.85
        ? "#8bc34a"
        : "#4caf50";

class EventTicketAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      groupByTicketBucket: false,
      showRangeEditor: false,
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      segmentFilterBy: "default",
      segmentFilter2By: "all",
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleSegmentFilterChange = this.handleSegmentFilterChange.bind(this);
    this.handleSegmentFilter2Change = this.handleSegmentFilter2Change.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getEventTicketAnalytics: AnalyticsStore.getEventTicketAnalytics,
      isFetching: AnalyticsStore.getState().isFetching
    };
  }

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  // default / ticket_bucket
  handleSegmentFilterChange(props) {
    this.setState({
      segmentFilterBy: props,
      groupByTicketBucket: props === "default" ? false : true,
    },
      () => this.componentWillReceiveProps(this.props, true)
    )
  }

  // default / ticket_bucket
  handleSegmentFilter2Change(props) {
    this.setState({ segmentFilter2By: props, },
      () => this.componentWillReceiveProps(this.props, true)
    )
  }

  handleDateChange({ range, allTime }) {
    this.setState({ range: range, allTime: allTime },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchEventTicketAnalytics.defer({
        eventBucketId: newProps.params.eventBucketId,
        filter2state: this.state.segmentFilter2By,
        startDate: !this.state.allTime ? JSON.stringify(this.state.range.startDate) : null,
        endDate: !this.state.allTime ? JSON.stringify(this.state.range.endDate) : null,
        allTime: this.state.allTime,
      });
      if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
        EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
      }
    }
  }

  render() {
    const { eventBucketId } = this.props.params;
    const eventBucket = this.props.getEventBucketById(eventBucketId);
    const eventTicketAnalytics = this.props.getEventTicketAnalytics(eventBucketId);
    const defaultItemsPerPage = 25;

    if (!eventTicketAnalytics || !eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    let data = eventTicketAnalytics.data.sort((a, b) =>
      (a.event.start_time || "").localeCompare(b.event.start_time || "")
    );

    let ticketBucketColumns;
    if (this.state.groupByTicketBucket) {
      let bucketNames = [];
      data.forEach(event => {
        if (event.by_ticket_bucket) {
          Object.keys(event.by_ticket_bucket).map(ticketBucketName => {
            if (bucketNames.indexOf(ticketBucketName) === -1) {
              bucketNames.push(ticketBucketName);
            }
          });
        }
      });
      bucketNames.sort((a, b) => {
        if (a === "Deleted ticket bucket") {
          return 1;
        } else if (b === "Deleted ticket bucket") {
          return -1;
        }
        return a.localeCompare(b);
      });
      ticketBucketColumns = bucketNames.map(ticketBucketName => {
        return {
          label: ticketBucketName,
          value: d => {
            if (
              d &&
              d.by_ticket_bucket &&
              d.by_ticket_bucket[ticketBucketName]
            ) {
              const { capacity, sold, unlimited } =
                d.by_ticket_bucket[ticketBucketName];
              return `${sold} / ${unlimited ? "∞" : capacity}`;
            } else {
              return "–";
            }
          }
        };
      });
    }

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="event analytics"
          subpath="events"
          query={this.props.location.query}
        // onRefresh={() => this.componentWillReceiveProps(this.props, true)}
        // isRefreshing={this.props.isFetching}
        />
        <FromCacheCallout analytics={eventTicketAnalytics} />
        <AnalyticsFilterWidget
          showDateFilter={true}
          onDateRangeChange={this.handleDateChange}

          showSegmentFilter={true}
          onSegmentFilterChange={this.handleSegmentFilterChange}
          segmentFilterTitle={"Group counts by"}
          segmentFilterSelected={this.state.segmentFilterBy}
          segmentFilterConfig={[
            {
              value: "default",
              label: "Sold / paid / pass / comp"
            },
            {
              value: "ticket_bucket",
              label: "Ticket bucket"
            }
          ]}

          showSegmentFilter2={true}
          onSegmentFilter2Change={this.handleSegmentFilter2Change}
          segmentFilter2Title={"Group by"}
          segmentFilter2Selected={this.state.segmentFilter2By}
          segmentFilter2Config={[
            {
              value: "all",
              label: "All Events"
            },
            {
              value: "physical",
              label: "Physical Events"
            },
            {
              value: "virtual",
              label: "Virtual Events"
            },
            {
              value: "undatedEvents",
              label: "Undated Events"
            },
          ]}

        />
        {
          this.props.isFetching
            ? (
              <div><WorkingIndicator fullPage={true} /></div>
            ) : (
              <div className="analytics-element">
                <GenericAnalyticsTable
                  eventBucket={eventBucket}
                  csvLabel="event-analytics"
                  showPdfDownload={true}
                  pdfFilename={util.snakeCase(`${eventBucket.name} analytics`)}
                  pdfTitle={`${eventBucket.name} analytics`}
                  defaultSort="Date"
                  defaultSortInvert={true}
                  itemsPerPage={defaultItemsPerPage}
                  columns={[
                    { label: "Event", value: "event" },
                    { label: "Venue", value: "venue", style: { whiteSpace: "nowrap" } },
                    { label: "Date", value: "date", style: { whiteSpace: "nowrap" } },
                    { label: "Capacity", value: "capacity" }
                  ]
                    .concat(
                      this.state.groupByTicketBucket
                        ? ticketBucketColumns
                        : [
                          { label: "Sold", value: "sold" },
                          { label: "Paid", value: "paid" },
                          { label: "Pass", value: "pass" },
                          { label: "Comp", value: "comp" }
                        ]
                    )
                    .concat([{ label: "Percent sold", value: "percent_sold" }])
                    .concat(
                      eventTicketAnalytics.data.some(d => d.hidden_capacity)
                        ? [{ label: "Hidden capacity", value: "hidden_capacity" }]
                        : []
                    )}
                  data={data.map(d => {
                    return {
                      event: {
                        label: d.event.name,
                        value: d.event.name,
                        itemClass: "data-limit",
                      },
                      venue: d.event.venue
                        ? { label: d.event.venue.name, value: d.event.venue.name, itemClass: "data-limit", }
                        : "–",
                      date: {
                        label: d.event.start_time
                          ? moment(d.event.start_time).format("llll")
                          : "–",
                        value: `${d.event.start_time}${d.event.venue ? d.event.venue.name : ""
                          }${d.event.name}`
                      },
                      capacity: d.unlimited ? "∞" : d.capacity,
                      sold: d.sold,
                      paid: {
                        label: d.paid,
                        value: d.paid,
                        itemStyle: { fontStyle: "italic" }
                      },
                      pass: {
                        label: d.pass,
                        value: d.pass,
                        itemStyle: { fontStyle: "italic" }
                      },
                      comp: {
                        label: d.comp,
                        value: d.comp,
                        itemStyle: { fontStyle: "italic" }
                      },
                      percent_sold: {
                        label: d.unlimited
                          ? "–"
                          : `${d.capacity === 0
                            ? "∞"
                            : ((d.sold * 100) / d.capacity || 0).toFixed(2)
                          }%`,
                        value: d.unlimited ? "unlimited" : d.sold / d.capacity,
                        itemStyle: {
                          backgroundColor: _color(d.sold / d.capacity),
                          color: "#fff",
                          borderBottom: "1px solid #fff"
                        }
                      },
                      hidden_capacity: d.hidden_capacity,
                      by_ticket_bucket: d.by_ticket_bucket
                    };
                  })}
                />
              </div>
            )}
      </div>
    );
  }
}

export default Radium(connectToStores(EventTicketAnalytics));



// WEBPACK FOOTER //
// ./src/app/components/event-ticket-analytics.jsx